import axiosInstance from "../axios_instance";

export async function createVaultSecret(body) {
  try {
    return await axiosInstance.post(`vault/`, body);
  } catch (error) {
    return error;
  }
}

export async function getUserVaultSecrets(userID, secretType) {
  try {
    const url = secretType
      ? `vault/user/${userID}/${secretType}`
      : `vault/user/${userID}`;
    return await axiosInstance.get(url);
  } catch (error) {
    return error;
  }
}

export async function getUserServiceDocumentFolders(body) {
  try {
    const url = `userServiceFolders/get-folders`;
    return await axiosInstance.post(url, body);
  } catch (error) {
    return error;
  }
}

export async function getVaultUsers(body) {
  try {
    return await axiosInstance.post('vault/get-users', body);
  } catch (error) {
    return error;
  }
}

export async function updateUserVaultSecret(body, userID) {
  try {
    const url = `vault/${userID}/${body?._id}`
    return await axiosInstance.put(url, body);
  } catch (error) {
    return error;
  }
}

export async function linkMicrosoftAcc(body) {
  try {
    const url = `user/microsoft/link`
    return await axiosInstance.post(url, body);
  } catch (error) {
    return error;
  }
}

export async function generateTwoFASecret() {
  try {
    const url = `user/2fa/generate`
    return await axiosInstance.get(url);
  } catch (error) {
    return error;
  }
}

export async function verifyTwoFASecret(body) {
  try {
    const url = `auth/2fa/verify`
    return await axiosInstance.post(url, body);
  } catch (error) {
    return error;
  }
}

export async function toggle2FA(body) {
  try {
    const url = `user/2fa/toggle`;
    return await axiosInstance.post(url, body);
  } catch (error) {
    return error;
  }
}
